export default __webpack_public_path__ + "static/media/mathruka_logo.4c6dee84.png";